import * as React from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import RefiPlaygroundBlockData from '../../../Models/Content/RefiPlaygroundBlockData';
import IdValidationPopup from '../OTPLoginBlock/Popups/idValidationPopup';

export interface RefiPlaygroundBlockProps {}

export interface RefiPlaygroundBlockState {}

class RefiPlaygroundBlock extends EpiComponent<RefiPlaygroundBlockData> {
  state = {};
  render() {
    return <IdValidationPopup closeModal={() => {}} />;
  }
}

export default RefiPlaygroundBlock;
